"use strict";

var moduleName = "form-change-data";

module.exports = function () {
	$(".jsFormChangeData").each(function () {
		if($.data(this, moduleName + "-init")) return;
		$.data(this, moduleName + "-init", true);



		//
		// Изменение личных данных. Скрываем/показываем поля формы
		//
		
		var radioFaceIndividual	 	= $(".jsRadioFaceIndividual"),
			radioFaceEntity   	    = $(".jsRadioFaceEntity"),
			formRowNameOrganization = $(".jsFormRowNameOrganization"),
			formRowInn 			  	= $(".jsFormRowInn");

		$(window).on("load", function() {

			if(radioFaceIndividual.prop("checked")) {
				formRowNameOrganization.hide();
				formRowInn.hide();
			}
		});

		$(".jsRadioFaceIndividual, .jsRadioFaceEntity").on("change", function() {

			if(radioFaceIndividual.prop("checked")) {
				formRowNameOrganization.hide();
				formRowInn.hide();
			} else {
				formRowNameOrganization.show();
				formRowInn.show();
			}
		});



	});
};


/** WEBPACK FOOTER **
 ** D:/phpstorm/szar/src/js/modules/formChangeDataInit.js
 **/